module.exports = __webpack_public_path__ + "img/logo-dark.72fb9578.png";